import { render, staticRenderFns } from "./userlist.vue?vue&type=template&id=4b898b65&scoped=true&"
import script from "./userlist.vue?vue&type=script&lang=tsx&"
export * from "./userlist.vue?vue&type=script&lang=tsx&"
import style0 from "./userlist.vue?vue&type=style&index=0&id=4b898b65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b898b65",
  null
  
)

export default component.exports